export const DEFAULT_FAVICON_HREF = '/favicon.svg';
export const DEFAULT_FAVICON_TYPE = 'image/svg+xml';
export const WORKSPACE_BRANDING_REFETCH_INTERVAL_MILLISECONDS = 600000;
